import { render, staticRenderFns } from "./TopNav_Avatar.vue?vue&type=template&id=1295f5f4&scoped=true&"
import script from "./TopNav_Avatar.vue?vue&type=script&lang=js&"
export * from "./TopNav_Avatar.vue?vue&type=script&lang=js&"
import style0 from "./TopNav_Avatar.vue?vue&type=style&index=0&id=1295f5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295f5f4",
  null
  
)

export default component.exports